<script setup lang="ts">
// const { initialization } = useInitialization();
// initialization();
import { usePageTitle } from '@/composables/usePageTitle'
usePageTitle()
</script>

<template>
  <router-view></router-view>
</template>

<style lang="scss" scoped></style>
